import { translateUi } from './index'

// These strings are generated by the application, rather than written by a
// customer. Do not translate arbitrary remarks using the general UI dictionary.
const systemRemarks = new Set([
  '账单生成，按本次件数将冻结费用转为正式扣费',
  '账单生成，本次冻结费用正式扣除',
  '账单生成，冻结费用正式扣除',
  '账单扣取押金后从可用余额自动补足',
  '押金扣款后从可用余额自动补足',
  '外部预报失败，自动退回冻结费用',
  '管理员立即退回冻结金额',
  '订单失败或删除，释放冻结费用',
  '撤销充值时退回押金补足部分',
  '直属推荐订单完成返利', '直属推荐订单返利冲回'
])

export function ledgerRemark (row) {
  const remark = row && row.remark
  if (row && row.bizType === 'DEPOSIT_CREDIT_REVERSAL' && /^管理员撤回押金充值（原流水 \d+）$/.test(remark)) return translateUi(remark)
  const automatic = row && ['ORDER_FREEZE', 'ORDER_UNFREEZE', 'ORDER_DEBIT', 'DEPOSIT_REPLENISH', 'DEPOSIT_REPLENISH_REVERSAL', 'REFERRAL_REWARD', 'REFERRAL_REVERSAL'].includes(row.bizType)
  return automatic && systemRemarks.has(remark) ? translateUi(remark) : remark
}
